export const Can_Display_Admin_UI = true;

export const QuestionType_Phone = 'PHONE';
export const QuestionType_Email = 'EMAIL';
export const QuestionType_Text = 'TEXT';
export const QuestionType_MCQ = 'MCQ';
export const QuestionType_MATRIX = 'MATRIX';

export const PDF_MatrixRowAndColumn_Seperator = ': ';
export const CSV_MatrixRowAndColumn_Seperator = ': ';
export const MatrixRowAndColumnText_Seperator = '~||~';
export const McqOption_Seperator = ',';
export const McqOption_OtherMcq = 'OTHER_MCQ';


export const SurveryState_Draft = 'DRAFT';
export const SurveryState_Published = 'PUBLISHED';

export const Token_Name = 'opusertoken';

export enum SurveyEditSteps {
    UnableToLoad = -1,
    Loading = 0,
    Start = 1,
    Group = 2,
    Question = 3,
    Summary = 4,
    Endnote = 5,
    Preview = 6,
    Publish = 7,
}

export enum EditObject {
    Survey = 1,
    Question,
    Group,
    SearchState
}

export enum MoveDirection {
  Up = 1,
  Down,
}

export enum BreakPointEnum {
  'xs',
  'sm',
  'md',
  'lg',
  'xl',
  'xxl',
}
